import api from "./axios-setup/axios";

export const PDF_DOCUMENTS_LIMIT = 200;

export const getAllPdfDocuments = async (skip = 0, limit = PDF_DOCUMENTS_LIMIT) => {
  const response = await api.get("/documents", {
    params: { skip, limit },
  });
  return response.data;
};

export const getPdfDocumentsByOrganization = async (
  orgId,
  skip = 0,
  limit = PDF_DOCUMENTS_LIMIT,
) => {
  const response = await api.get(`/organizations/${encodeURIComponent(orgId)}/documents`, {
    params: { skip, limit },
  });
  return response.data;
};

export const uploadPdfDocuments = async (files, orgId) => {
  const formData = new FormData();
  files.forEach((file) => {
    formData.append("files", file);
  });

  const response = await api.post("/upload", formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
    params: orgId ? { org_id: orgId } : undefined,
  });

  return response.data;
};

export const replacePdfDocument = async (documentId, file) => {
  const formData = new FormData();
  formData.append("file", file);

  const response = await api.put(`/documents/${documentId}`, formData, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });

  return response.data;
};

export const deletePdfDocument = async (documentId) => {
  await api.delete(`/documents/${documentId}`);
};
